var map = {
	"./de/general13/slide2.svg": 342398,
	"./en/general13/slide2.svg": 69826,
	"./es/general13/slide2.svg": 399677,
	"./fr/general13/slide2.svg": 270949,
	"./nl/general13/slide2.svg": 558715,
	"./pt/general13/slide2.svg": 858473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 342208;